import { DASHBOARD_DETAIL_ADMIN, DASHBOARD_GRAPH,NEW_DASHBOARD_DETAILS,
  DASHBOARD_CLOSING,DASHBOARD_SOURCING,DASHBOARD_SCM,
  DASHBOARD_SITEHEAD,  DASHBOARD_RECEIPTIONIST,DASHBOARD_POSTSALE,DASHBOARD_CSTL
 } from "../types";
import strings from "translate/language";
import { errorToast, unAuthorizedError } from "utils/httpClient";
import dashboardService from "../service/dashboardService";

export const getDashboardDetail = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardDetail(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_DETAIL_ADMIN,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getDashboardGraphAction = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardGraph(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_GRAPH,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getNewDashboardDetails = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getNewDashboardDetails(item);
    if (res.data.status === 200) {
      dispatch({
        type: NEW_DASHBOARD_DETAILS,
        payload: res.data,
      });
    }
    // Non-super-admin / empty insights — silent (do not toast "Data not found")
  } catch (e) {
    const data = e?.response?.data;
    if (
      data?.status === 401 ||
      data?.status === 400 ||
      data?.status === 403
    ) {
      unAuthorizedError(data);
      return;
    }
    // Ignore expected empty insights responses; only toast real failures
    if (data?.message && data?.status !== 201) {
      errorToast(data.message);
    }
  }
};

export const getDashboardSourcing = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardSourcing(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_SOURCING,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};


export const getDashboardClosing = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardClosing(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_CLOSING,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getDashboardSCM = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardSCM(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_SCM,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getDashboardSiteHead = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardSiteHead(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_SITEHEAD,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getDashboardReceiptionist = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardReceiptionist(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_RECEIPTIONIST,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getDashboardPostSale = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardPostSale(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_POSTSALE,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getDashboardCstl = (item) => async (dispatch) => {
  try {
    const res = await dashboardService.getDashboardCstl(item);
    if (res.data.status === 200) {
      dispatch({
        type: DASHBOARD_CSTL,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};


